import React from 'react';
import './Skills.css';
import CPlusPlus from '../images/CPlusPlusLogo.png';
import Java from '../images/JavaLogo.png';
import HTML from '../images/HtmlLogo.png';
import CSS from '../images/CSSLogo.png';
import JS from '../images/JSLogo.png';
import NodeJS from '../images/nodejsLogo.png';
import ReactJS from '../images/reactjsLogo.png';
import Bootstraps from '../images/BootstrapsLogo.png';
import Figma from '../images/FigmaLogo.png';
import Firebase from '../images/FirebaseDBLogo.png';
import Illustrator from '../images/IllustratorLogo.png';
import Laravel from '../images/LaravelLogo.png';
import Linux from '../images/LinuxLogo.png';
import MariaDB from '../images/MariaDBLogo.png';
import MongoDB from '../images/MongoDBLogo.png';
import MySQL from '../images/MySqlLogo.png';
import Photoshop from '../images/PhotoShopLogo.png';
import PHP from '../images/PHPLogo.png';
import Python from '../images/PythonLogo.png';
import Swift from '../images/SwiftLogo.png';
import PowerApps from '../images/MSPowerAppsLogo.png';
import PowerBI from '../images/PowerBILogo.png';
import Automate from '../images/AutomateLogo.png';
import VA from '../images/VirtualAgents.png';

function Skills() {
  return (
    <div className='skills-container' id='skills'>
      <h1 className='skills-title'>Skills</h1>
      <div className='skills-list'>
        <img src={CPlusPlus} className='skills-icon'/>
        <img src={Java} className='skills-icon'/>
        <img src={HTML} className='skills-icon'/>
        <img src={CSS} className='skills-icon'/>
        <img src={JS} className='skills-icon'/>
        <img src={NodeJS} className='skills-icon'/>
        <img src={ReactJS} className='skills-icon'/>
        <img src={PHP} className='skills-icon'/>
        <img src={Laravel} className='skills-icon'/>
        <img src={Python} className='skills-icon'/>
        <img src={Bootstraps} className='skills-icon'/>
        <img src={Swift} className='skills-icon'/>
        <img src={Linux} className='skills-icon'/>
        <img src={MySQL} className='skills-icon'/>
        <img src={MongoDB} className='skills-icon'/>
        <img src={MariaDB} className='skills-icon'/>
        <img src={Firebase} className='skills-icon'/>
        <img src={Figma} className='skills-icon'/>
        <img src={Illustrator} className='skills-icon'/>
        <img src={Photoshop} className='skills-icon'/>
        <img src={PowerApps} className='skills-icon'/>
        <img src={PowerBI} className='skills-icon'/>
        <img src={Automate} className='skills-icon'/>
        <img src={VA} className='skills-icon'/>
      </div>
    </div>
  );
}

export default Skills;